/**
 * Prevents the body from scrolling when a modal or dropdown is open
 * by adding/removing a CSS class that typically sets overflow: hidden on the body.
 *
 * @param preventScroll - Whether to prevent body scrolling (true) or allow it (false)
 * @returns A cleanup function that removes the scroll prevention
 */
export const preventBodyScrollOnModal = (preventScroll: boolean) => {
    if (preventScroll) {
        document.body.classList.add('fix-body');
    } else {
        document.body.classList.remove('fix-body');
    }

    return () => {
        document.body.classList.remove('fix-body');
    };
};
